<div *ngIf="(privacyPolicyURI | async) !== undefined">
  <pdf-viewer
    [src]="pdf"
    [render-text]="true"
    [autoresize]="true"
    [show-borders]="true"
    [render-text-mode]="2"
  ></pdf-viewer>
</div>
